import { render } from "./tw-list-view.vue?vue&type=template&id=28654ef0"
import script from "./tw-list-view.vue?vue&type=script&lang=js"
export * from "./tw-list-view.vue?vue&type=script&lang=js"
script.render = render

export default script